const prefix = 'far';
const iconName = 'columns-3';
const width = 640;
const height = 512;
const aliases = [];
const unicode = 'e361';
const svgPathData = 'M448 80V432H576c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H448zm-48 0H240V432H400V80zM192 432V80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H192zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
